import { useOrganisationsQuery } from "@sso/apis/organisations";
import { UserRole } from "@sso/constant";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectCurrentUser } from "@sso/store/slices/auth";
import { selectOrganisationQuery } from "@sso/store/slices/organisation";

export const useGetOrganisationsQuery = () => {
  const currentUser = useAppSelector(selectCurrentUser);
  const skip = currentUser?.role.roleId !== UserRole.ADMINISTRATOR;
  const queryParams = useAppSelector(selectOrganisationQuery);
  return useOrganisationsQuery(queryParams, { skip });
};
